<template>
  <BriefStep :title="title" :tooltip="tooltip">
    <template v-slot:content>
      <div class="brief-form">
        <div class="brief-form">
          <div
            class="
              form__input-wrapper
              form__input-wrapper--check
              form__input-wrapper--check-squer
            "
            v-for="checkbox in formCheckboxes"
            :key="checkbox.name"
          >
            <input
              class=""
              :id="checkbox.name"
              type="checkbox"
              :name="checkbox.name"
              :value="checkbox.value"
              v-model.trim="form.siteFunctions"
              @input="invokeTouch($v.form.siteFunctions)"
            />
            <label :for="checkbox.name" class="form__label">{{
              checkbox.label
            }}</label>
          </div>
          <div
            class="
              form__input-wrapper
              form__input-wrapper--check
              form__input-wrapper--check-squer
            "
          >
            <input
              class=""
              id="sf-other"
              type="checkbox"
              name="other"
              value="Inne"
              @input="invokeTouch($v.form.siteFunctions)"
              @click="otherHandler"
            />
            <label for="sf-other" class="form__label"
              >strona w kilku językach - jakich?</label
            >
          </div>
          <transition name="fade-input">
            <div
              v-if="hasDescription"
              class="form__input-wrapper"
              :class="{ error: $v.form.siteFunctionsLanguages.$anyError }"
            >
              <label for="siteFunctionsLanguages" class="form__label uk-hidden"
                >Podaj inne</label
              >
              <input
                class="form-input uk-width-1-1"
                id="siteFunctionsLanguages"
                type="text"
                name="siteFunctionsLanguages"
                ref="otherInput"
                @input="event => delayTouchCounterComposition($v.form, 'siteFunctionsLanguages', event.target.value)"
              />
              <span class="form__error-message form__error-message--no-label">
                <template v-if="!$v.form.siteFunctionsLanguages.minLength">
                  {{ validationMessage.minLength }}</template
                >
                <template v-if="!$v.form.siteFunctionsLanguages.required">
                  {{ validationMessage.required }}</template
                >
              </span>
            </div>
          </transition>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'SiteFunctions',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      'Wygląd to nie wszystko. Najważniejsze jest bogate wnętrze. Jakich funkcji '
      + 'od strony oczekujesz?',
    tooltip:
      'Podstawowe funkcje takie jak tradycyjne '
      + 'systemy płatności czy systemy mailowe są w cenie.',
    form: {
      siteFunctions: [],
      siteFunctionsLanguages: '',
    },
    hasDescription: false,
    formCheckboxes: [
      {
        name: 'sf-orders',
        value: 'składanie zamówień online',
        label: 'składanie zamówień online',
      },
      {
        name: 'sf-payment',
        value: 'płatności internetowe',
        label: 'płatności internetowe',
      },
      {
        name: 'sf-newsletter',
        value: 'możliwość zapisywania się do newslettera',
        label: 'możliwość zapisywania się do newslettera',
      },
      {
        name: 'sf-search-engine',
        value: 'wyszukiwarka treści na stronie',
        label: 'wyszukiwarka treści na stronie',
      },
      {
        name: 'sf-blog',
        value: 'blog',
        label: 'blog',
      },
      {
        name: 'sf-contact',
        value: 'formularz kontaktowy',
        label: 'formularz kontaktowy',
      },
      {
        name: 'sf-allegro',
        value: 'integracja z allegro.pl',
        label: 'integracja z allegro.pl',
      },
      {
        name: 'sf-marketplace',
        value: 'integracja z innymi marketplace-ami (Amazon, Ebay, itd.)',
        label: 'integracja z innymi marketplace-ami (Amazon, Ebay, itd.)',
      },
      {
        name: 'sf-social',
        value: 'odnośniki do portali społecznościowych',
        label: 'odnośniki do portali społecznościowych',
      },
    ],
  }),
  validations() {
    if (!this.hasDescription) {
      return {
        form: {
          siteFunctions: {
            required,
          },
        },
      };
    }
    return {
      form: {
        siteFunctions: {
          required,
        },
        siteFunctionsLanguages: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
  methods: {
    otherHandler() {
      this.hasDescription = !this.hasDescription;

      if (!this.hasDescription) {
        this.form.siteFunctionsLanguages = '';
      } else {
        setTimeout(() => {
          this.$refs.otherInput.focus();
        }, 100);
      }
    },
  },
};
</script>
<style scoped>
</style>
